<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" scrollable max-width="500">
    <ValidationObserver ref="obs">
      <v-card>
        <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Eliminar Contacto
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense>
                <v-col cols="12">
                  <v-card-title class="font-weight-medium ">
                    Esta seguro que desea eliminar este Contacto
                  </v-card-title>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog">
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="error"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="deleteContact()"
            >
              Eliminar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async deleteContact() {
      this.isLoading = true;
      try {
        await PbxHttpClient.delete(`/admin/contacts/${this.id}`);
        this.$snotify.success("Contacto eliminado con exito", "¡Hecho!");
        this.closeDialog(this.id);
      } catch (err) {
        //   console.log(err)
        this.$snotify.error("No se pudo eliminar el contacto.", "¡Error!");
      }
      this.isLoading = false;
    },
    closeDialog(id = false) {
      if (id) this.$emit("dialog:close", id);
      else this.$emit("dialog:close");
    },
  },
};
</script>

<style></style>
